import {Environment} from "../../../environments/Environment";
import {BuildInfo} from "../../../BuildInfo";

export class GlobalConfig {

  public static readonly production: boolean = Environment.production;
  public static readonly environment: string = Environment.environment;
  public static readonly version: string = Environment.version;
  public static readonly buildNumber: string = BuildInfo.buildNumber;
  public static readonly buildTimestamp: string = BuildInfo.buildTimestamp;

  public static readonly gaTrackingId: string = Environment.gaTagId;

  public static readonly googleMapsApiKey: string = Environment.googleMapsApiKey;

  public static readonly gatewayUrl = Environment.gatewayUrl;
  public static readonly socketIoServerUrl = Environment.socketIoServerUrl;
  public static readonly socketIoServerSecure = Environment.socketIoServerSecure;
  public static readonly apiUrl = GlobalConfig.gatewayUrl + '/V1/API';
  public static readonly nbApiUrl = GlobalConfig.gatewayUrl + '/V1/NB-API';
  public static readonly dataApiUrl = GlobalConfig.gatewayUrl + '/V1/DATA-API';
  public static readonly loginEndpoint = Environment.gatewayUrl + '/CG/login';
  public static readonly checkSsoEndpoint = Environment.gatewayUrl + '/CG/check-sso';
  public static readonly loginWithSsoCodeEndpoint = Environment.gatewayUrl + '/CG/login-with-sso-code';
  public static readonly refreshSsoAccessTokenEndpoint = GlobalConfig.gatewayUrl + '/CG/refresh-sso-access-token';
  public static readonly refreshAccessTokenEndpoint = GlobalConfig.gatewayUrl + '/CG/refreshAccessToken';

  public static endpoints = {
    assetAlertRules: GlobalConfig.apiUrl + '/alert/asset/rules',
    lineAlertRules: GlobalConfig.apiUrl + '/alert/line/rules',
    alertRule: GlobalConfig.apiUrl + '/alert/rule',
    alertRules: GlobalConfig.apiUrl + '/alert/rules',
    assets: GlobalConfig.apiUrl + '/assets',
    assetTypes: GlobalConfig.apiUrl + '/assets/types',
    assetTypeOptions: GlobalConfig.apiUrl + '/assets/types/options',
    assetTypePropertyFriendlyNameTranslations: GlobalConfig.apiUrl + '/config/getAssetTypePropertyFriendlyNameTranslations',
    assetTypeVersions: GlobalConfig.apiUrl + '/assets/types/versions',
    clients: GlobalConfig.apiUrl + '/companies',
    cms: GlobalConfig.apiUrl + '/cms',
    createDashboards:  GlobalConfig.apiUrl + '/dashboards/createDashboards',
    dashboard: GlobalConfig.apiUrl + '/dashboards',
    dateTimeFormats: GlobalConfig.apiUrl + '/config/datetimeformats',
    files: GlobalConfig.apiUrl + '/files',
    streamingFileUpload: GlobalConfig.nbApiUrl + '/files/upload',
    fetchAssetTypeParamDoc: GlobalConfig.apiUrl + '/files/createOrFetchAssetTypeParamFile',
    gateways: GlobalConfig.apiUrl + '/gateways',
    languages: GlobalConfig.apiUrl + '/config/languages',
    lines: GlobalConfig.apiUrl + '/lines',
    cloneLineMappings: GlobalConfig.apiUrl + '/lines/clones',
    lineSegments: GlobalConfig.apiUrl + '/lineSegments',
    manualAlerts: GlobalConfig.apiUrl + '/custom-alerts',
    marketSectors: GlobalConfig.apiUrl + '/plants/marketsectors',
    masterTranslation: GlobalConfig.apiUrl + '/config/mastertranslations',
    megacharts: GlobalConfig.apiUrl + '/trend-dashboards/megacharts',
    paramUpdate: GlobalConfig.apiUrl + '/files/AssetParamDocTransform',
    placeholderAssets: GlobalConfig.apiUrl + '/assets/placeholder-assets',
    plants: GlobalConfig.apiUrl + '/plants',
    regions: GlobalConfig.apiUrl + '/config/regions',
    rejectGroups: GlobalConfig.apiUrl + '/rejectgroups',
    remedies: GlobalConfig.apiUrl + '/remedies',
    uiBuildInfo: GlobalConfig.apiUrl + '/ui-build-info',
    reportTemplates: GlobalConfig.apiUrl + '/reports/templates',
    reportSubscriptions: GlobalConfig.apiUrl + '/reports/subscriptions',
    roles: GlobalConfig.apiUrl + '/users/roles',
    rooms: GlobalConfig.apiUrl + '/rooms',
    shifts: GlobalConfig.apiUrl + '/lines/shifts',
    supportTickets: GlobalConfig.apiUrl + '/support-tickets',
    translation: GlobalConfig.apiUrl + '/config/translationfile',
    tileGroups: GlobalConfig.apiUrl + '/tilegroups',
    tileTemplates: GlobalConfig.apiUrl + '/tile-templates',
    trendDashboard: GlobalConfig.apiUrl + '/trend-dashboards',
    updateassetTypePropertyFriendlyNameTranslations: GlobalConfig.apiUrl + '/files/updateAssetTypePropertyFriendlyNameTranslations',
    users: GlobalConfig.apiUrl + '/users',
    getCurrentUser: GlobalConfig.apiUrl + '/users/getCurrentUser',
    userAlertSubscriptions: GlobalConfig.apiUrl + '/users/alert-subscriptions',
    userAlertPreference: GlobalConfig.apiUrl + '/users/alert-level-subscription',
    updateAlertPreferenceSubscriptions: GlobalConfig.apiUrl + '/users/rule-alert-subscriptions',
    userExists: GlobalConfig.apiUrl + '/users/exist',
    translationObject: GlobalConfig.apiUrl + '/config/languageTranslationMap',
    screenAccess: GlobalConfig.apiUrl + '/screenaccess',
    requestResetEmail: GlobalConfig.apiUrl + '/users/request-reset-token',
    resetPassword: GlobalConfig.apiUrl + '/users/reset-password',
    entityTree: GlobalConfig.apiUrl + '/config/entitytree',
    countries: GlobalConfig.apiUrl + '/config/countries',
    dataContracts: GlobalConfig.apiUrl + '/datacontracts',
    errorCodes: GlobalConfig.apiUrl + '/config/errorcodes',
    uom: GlobalConfig.apiUrl + '/config/unitofmeasures'
  }

  public static dataApiEndpoints = {
    alertData: GlobalConfig.dataApiUrl + '/link/alert',
    assetData: GlobalConfig.dataApiUrl + '/link/asset/data',
    ingestData: GlobalConfig.dataApiUrl + '/link/ingestion',
    lineData: GlobalConfig.dataApiUrl + '/link/line/data',
  };

  public static screenNames = {
    assetTableComponent: 'AssetListComponent',
    clientTableComponent: 'ClientListComponent',
    remedyTableComponent: 'RemedyListComponent',
    assetTypeOptionTableComponent: 'OptionListComponent_list',
    lineTableComponent: 'LineListComponent',
    assetTypeTableComponent: 'AssetTypeListComponent',
    roomTableComponent: 'RoomListComponent',
    userTableComponent: 'SeeUserListComponent',
    alertListComponent: 'AlertMonitorComponent',
    manageConfigComponent: 'ManageConfigComponent',
    gatewayTableComponent: 'GatewayListComponent',
    placeholderAssetListComponent: 'PlaceholderAssetListComponent',
    rejectGroupListComponent: 'RejectGroupListComponent',
    lineSegmentListComponent: 'LineSegmentListComponent',
    headerNodeListComponent: 'HeaderNodeListComponent',
    videoNodeListComponent: 'VideoNodeListComponent',
    shiftTableComponent: 'shiftListComponent',
    plantTableComponent: 'PlantListComponent',
    alertSubscriptionsComponent: 'AlertSubscriptionsComponent',
    reportTemplateTable: 'ReportTemplateTable',
    graphicsAssetTable: 'GraphicsAssetTable',
    graphicsAssetFilesTable: 'GraphicsAssetFilesTable',
  };

  public static roles = {
    seeSolutionCenter: 'solution_center_see_',
    seeRDSeed: 'r_d_seed_see_',
    // seeSAManager: 's_a_manager_see_', (Will be used as seeSATechnician)
    seeSATechnician: 's_a_technician_see_',
    seeSales: 'sales_see_',
    client: 'client',
    subUserManagementExternal: 'management_external_',
    subUserMaintenanceIT: 'maintenance_it_external_',
    subUserOperator: 'operator_external_',
    subUserCustomerAdmin: 'customer_admin_external_'
  };

  public static entityType = {
    node: 'node',
    taxonomy_term: 'taxonomy-term',
    user: 'user'
  };
  public static entityId = {
    asset: 'asset',
    placeholderAsset: 'placeholderAsset',
    asset_type: 'asset_type',
    line: 'line',
    option: 'options',
    plant: 'plant',
    room: 'room',
    shift: 'shift',
    version: 'versions',
    parameter: 'parameter',
    client: 'client',
    subuser: 'subuser',
    seeuser: 'see',
    report: 'report',
    lineSegment: 'lineSegment'
  };

  public static defaultRejectPackagingWindow = 100;
}
